export const langsSupported = [
  'en',
  'ar',
  'es',
  'hi',
  'zh',
  'bn',
  'pt',
  'fr',
  'ru',
  'ur',
];
